import { useKeycloak } from '@react-keycloak/web';
import { FC, ReactNode, useEffect } from 'react';

import dayjs from 'dayjs';
import 'dayjs/locale/ro';
import i18n from 'i18next';

import { UserInfo } from '@/api/data-contracts';
import { useUsersService } from '@/features/users';

interface Props {
  children: ReactNode;
}

// i18n itself is initialised in main.tsx (initI18n); this only switches to the
// user's profile language once they are signed in.
const InternationalizationProvider: FC<Props> = ({ children }) => {
  const { initialized, keycloak } = useKeycloak();
  const { getCurrentUserDetails } = useUsersService();

  useEffect(() => {
    if (initialized && keycloak?.token) {
      getCurrentUserDetails()
        .then((user: UserInfo) => {
          const lang = user?.language === 'Romanian' ? 'ro' : 'en';
          i18n.changeLanguage(lang);
          dayjs.locale(lang);
        })
        .catch((error: unknown) => {
          // The UI stays in English until the next sign-in; nothing to show the user.
          console.error('Could not load the user language', error);
        });
    }
    // eslint-disable-next-line
  }, [initialized, keycloak?.token]);

  return <>{children}</>;
};

export default InternationalizationProvider;
